<template>
	<li
		v-if="item"
		:class="$style['dropdown-menu-item']"
	>
		<DropdownMenuLink
			v-testid="'department-name'"
			:item="item"
			@click="handleItemClick($event, item)"
		/>
	</li>
	<li
		v-else
		:class="$style['dropdown-menu-item']"
	>
		<slot />
	</li>
</template>
<script>
import DropdownMenuLink from './DropdownMenuLink'
export default {
	name: 'DropdownMenuItem',
	components: {
		DropdownMenuLink
	},
	props: {
		item: {
			type: Object,
			default: () => ({})
		}
	},
	methods: {
		handleItemClick (e, item) {
			e.stopPropagation()
			if (item.to) {
				const navigation = this.$router.push(item.to)
				if (navigation && typeof navigation.catch === 'function') {
					navigation.catch(err => {
						if (err?.name !== 'NavigationDuplicated') {
							console.error('Navigation Error:', err)
						}
					})
				}
			}
			if (item.click) {
				item.click(e)
			}
			this.$emit('dropdown-toggle', e)
		}
	}
}
</script>
<style lang="scss" module>
.dropdown-menu-item {
		list-style: none;
		padding: 0;
	}
</style>
